module.exports = __webpack_public_path__ + "img/back3.e9511976.png";